// extracted by mini-css-extract-plugin
export default {"mainHeader":"Immunisation_mainHeader__HYXW7"};